export default "__VITE_ASSET__CFNAtlaS__"